"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ssrDataJson = void 0;
exports.ssrDataJson = {
  "synonyms": [{
    "name": "ALGO_ONE",
    "value": ["SSI5", "SPAK", "SMD7", "SKLB", "SXAI"]
  }, {
    "name": "ALGO_TWO",
    "value": ["SRX5", "SRDJ", "SLAK", "SKD7", "SBZ2"]
  }, {
    "name": "ALGO_THREE",
    "value": ["SPGR", "SMDJ", "SMXT", "SZQZ", "SLXT"]
  }, {
    "name": "ALGO_FOUR",
    "value": ["SSXT", "SLZ2", "SRXT", "SAI5", "SBI5"]
  }, {
    "name": "ALGO_FIVE",
    "value": ["SLD7", "SQXJ", "SOXT", "SBFD", "SYXT"]
  }],
  "api_data": [{
    "source": "validation",
    "id": "yuyt0i39"
  }, {
    "source": "traveldoc",
    "id": "ntoc3fj4"
  }, {
    "source": "autoseat",
    "id": "kzsas23k"
  }, {
    "source": "addons",
    "id": "lmdok7d1"
  }, {
    "source": "seat",
    "id": "w4gfhjt2"
  }, {
    "source": "checkout",
    "id": "qmzp52u2"
  }, {
    "source": "checkinchain",
    "id": "hj78hja3"
  }]
};